import React from 'react';
import usePrivacyPolicy from './usePrivacyPolicy';

const PrivacyPolicy: React.FC = () => {
    const {
        sections,
        handleSectionChange,
        handleSubtitleChange,
        handleTextFieldChange,
        handleTitleTextFieldChange,
        addSection,
        addSubtitle,
        addTextField,
        addTitleTextField,
        saveSections,
        deleteSection,
        deleteSubtitle,
        deleteTextField,
        deleteTitleTextField,
        deleteAll,
    } = usePrivacyPolicy();

    return (
        <div className="container mx-auto p-4">
            <div className='flex w-full mb-6 justify-between items-center'>
                <h1 className="text-3xl font-bold text-center flex-grow">Privacy Policy</h1>
                <button onClick={deleteAll} className="bg-red-500 text-white px-3 py-1 ml-2 rounded"> DELETE ALL </button>
            </div>
            {sections && Array.isArray(sections) && sections.map((section, sectionIndex) => (
                <div key={sectionIndex} className="mb-8 p-4 border rounded-lg shadow-lg bg-white">Title {sectionIndex + 1} :
                    <div className="flex items-center mb-4 mt-2">
                        <input
                            type="text"
                            placeholder="Section Title"
                            value={section.title}
                            onChange={(e) => handleSectionChange(sectionIndex, 'title', e.target.value)}
                            className="border p-2 w-full text-lg font-semibold"
                        />
                        {sections.length > 1 && (
                            <button
                                onClick={() => deleteSection(sectionIndex)}
                                className="bg-red-500 text-white px-3 py-1 ml-2 rounded"
                            >
                                Delete
                            </button>
                        )}
                    </div>
                    {section.textFields && Array.isArray(section.textFields) && section.textFields.map((textField, textFieldIndex) => (
                        <div key={textFieldIndex} className="flex items-center mb-2 ml-6">
                            <input
                                type="text"
                                placeholder="Text Field"
                                value={textField.text}
                                onChange={(e) => handleTitleTextFieldChange(sectionIndex, textFieldIndex, e.target.value)}
                                className="border p-2 w-full text-sm"
                            />
                            {section.textFields.length > 1 && (
                                <button
                                    onClick={() => deleteTitleTextField(sectionIndex, textFieldIndex)}
                                    className="bg-red-500 text-white px-2 py-1 ml-2 rounded"
                                >
                                    Delete
                                </button>
                            )}
                        </div>
                    ))}
                    <button
                        onClick={() => addTitleTextField(sectionIndex)}
                        className="bg-blue-500 text-white px-4 py-2 rounded mt-2 ml-5"
                    >
                        Add Text Field to Title
                    </button>
                    {section.subtitles && Array.isArray(section.subtitles) && section.subtitles.map((subtitle, subtitleIndex) => (
                        <div key={subtitleIndex} className="ml-6 mb-6 mt-8"> Sub-Title {subtitleIndex + 1} :
                            <div className="flex items-center mb-2">
                                <input
                                    type="text"
                                    placeholder="Subtitle"
                                    value={subtitle.subtitle}
                                    onChange={(e) => handleSubtitleChange(sectionIndex, subtitleIndex, 'subtitle', e.target.value)}
                                    className="border p-2 w-full text-md font-medium"
                                />
                                {section.subtitles.length > 1 && (
                                    <button
                                        onClick={() => deleteSubtitle(sectionIndex, subtitleIndex)}
                                        className="bg-red-500 text-white px-2 py-1 ml-2 rounded"
                                    >
                                        Delete
                                    </button>
                                )}
                            </div>
                            {subtitle.textFields && Array.isArray(subtitle.textFields) && subtitle.textFields.map((textField, textFieldIndex) => (
                                <div key={textFieldIndex} className="flex items-center mb-2 ml-6">
                                    <input
                                        type="text"
                                        placeholder="Text Field"
                                        value={textField.text}
                                        onChange={(e) => handleTextFieldChange(sectionIndex, subtitleIndex, textFieldIndex, e.target.value)}
                                        className="border p-2 w-full text-sm"
                                    />
                                    {subtitle.textFields.length > 1 && (
                                        <button
                                            onClick={() => deleteTextField(sectionIndex, subtitleIndex, textFieldIndex)}
                                            className="bg-red-500 text-white px-2 py-1 ml-2 rounded"
                                        >
                                            Delete
                                        </button>
                                    )}
                                </div>
                            ))}
                            <button
                                onClick={() => addTextField(sectionIndex, subtitleIndex)}
                                className="bg-blue-500 text-white px-4 py-2 rounded mt-2"
                            >
                                Add Text Field
                            </button>
                        </div>
                    ))}
                    <button
                        onClick={() => addSubtitle(sectionIndex)}
                        className="bg-green-500 text-white px-4 py-2 rounded mt-4"
                    >
                        Add Subtitle
                    </button>
                    
                </div>
            ))}
            <button onClick={addSection} className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded block w-full mb-4">
                Add Section
            </button>
            <button onClick={saveSections} className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded block w-4/5 
            md:w-1/5 mx-auto mb-4 fixed bottom-2 ml-[36rem] transform -translate-x-1/2">
                Save
            </button>
        </div>
    );
};

export default PrivacyPolicy;